export default __webpack_public_path__ + "static/fall6-80a196b6d0c21dea72961f6da3729052.webp";